<script>
  import {
    VTimelineItem
  } from 'vuetify/lib'
  export default {
    name: 'wh-timeline-item',
    extends: VTimelineItem
  };
</script>